import { render, staticRenderFns } from "./NewsGrid.vue?vue&type=template&id=68fc1647&scoped=true&"
import script from "./NewsGrid.vue?vue&type=script&lang=js&"
export * from "./NewsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc1647",
  null
  
)

export default component.exports